import React, { useMemo } from 'react';

import { useAccountContext } from '../../contexts/AccountContext';

interface RequireEntitlementsProps {
  entitlement: string;
  children: React.ReactNode;
}

const RequireEntitlements: React.FC<RequireEntitlementsProps> = (props) => {
  const accountContext = useAccountContext();


  const result = useMemo(() => {
    const hasEntitlement = accountContext.currentAccountEntitlementComponents.findIndex((e) => e.label === props.entitlement) !== -1;

    if (hasEntitlement) {
      return <>{props.children}</>;
    }

    return <>
      <div className='flex -h-screen-nav'>
      <div className='flex flex-col mx-auto my-auto'>
        <div className='mx-auto'>
          <svg className={'fill-foreground h-60'}>
            <use href={'/icons.svg#cybro-sitting'} />
          </svg>
        </div>
        <h1 className='text-xl md:text-4xl pb-4 text-center'>{accountContext.currentAccount?.name} doesn't have an entitlement for {props.entitlement}.</h1>
      </div>
  </div>
    </>;
  }, [accountContext.currentAccountEntitlementComponents])

  return result;
  
};

export default RequireEntitlements;